module.exports = __webpack_public_path__ + "static/media/home_bg3.b547348b.webp";